import { httpClientInterface, requireEnvironmentConfig } from 'app-components/utils/core';
import AxiosFactory from 'utils/axiosFactory';

const qcsAxios = AxiosFactory.get('qcs');

// implement shared interfaces
httpClientInterface.httpClientInterfaceInit({
  getServiceUrl: () => requireEnvironmentConfig().services_url,
  getAxios: () => qcsAxios,
  send: (method, url, data, headers, params, properties) => {
    const config = { ...properties, headers, params };
    switch (method) {
      case 'GET':
        return qcsAxios.get(url, config);
      case 'POST':
        return qcsAxios.post(url, data, config);
      case 'PUT':
        return qcsAxios.put(url, data, config);
      case 'DELETE':
        return qcsAxios.delete(url, config);
      case 'PATCH':
        return qcsAxios.patch(url, data, config);
    }
  },
});
